<template>
  <v-navigation-drawer
    v-model="primaryDrawer"
    fixed
    :app="fluidSidebar"
    :mobile-break-point="1264"
    class="primary primary-drawer"
    dark
    :width="drawerSizes.primary.full"
    :mini-variant-width="drawerSizes.primary.mini"
    :mini-variant="mini"
  >
    <div class="primary-drawer__wrap">
      <v-list subheader class="primary-drawer__nav">
        <v-list-tile>
          <v-spacer></v-spacer>
          <v-list-tile-action>
            <v-btn icon flat color="tertiary" @click.stop="mini = !mini">
              <div class="v-icon">
                <fa-icon :icon="['far', mini ? 'chevron-right' : 'chevron-left']" size="sm" />
              </div>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile
          ripple
          class="secondary"
          avatar
          @click.stop="SET_VALUE({ name: 'profileDrawer', value: !profileDrawer }); $vuetify.breakpoint.smAndDown ? primaryDrawer = false : primaryDrawer = true"
        >
          <v-list-tile-avatar>
            <v-avatar>
              <img :src="user.photo_url" :alt="user.name" />
            </v-avatar>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="tertiary--text">{{getObjectValue('role.name', user)}}</v-list-tile-title>
            <v-list-tile-sub-title class="white--text bold">{{user.name}}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-subheader class="pt-4 tertiary--text">Tools</v-subheader>

        <v-list-tile
          ripple
          class="primary-drawer__link tertiary--text"
          color="tertiary"
          :to="item.href"
          v-for="item in primaryRoutes"
          :key="item.title"
        >
          <v-list-tile-action v-if="!mini">
            <div class="v-icon v-icon--left">
              <fa-icon :icon="item.icon" size="sm" fixed-width style="opacity: 0.6" />
            </div>
          </v-list-tile-action>

          <v-tooltip right v-else>
            <template v-slot:activator="{ on }">
              <v-list-tile-action v-on="on">
                <div class="v-icon v-icon--left">
                  <fa-icon :icon="item.icon" size="sm" fixed-width style="opacity: 0.6" />
                </div>
              </v-list-tile-action>
            </template>
            <span>{{ item.title }}</span>
          </v-tooltip>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action
            :class="{'v-list__tile__action--badge': mini}"
            v-if="getObjectValue('extra.type', item)"
          >
            <div
              :is="item.extra.type"
              :name="getObjectValue('extra.name', item, null)"
              :params="getObjectValue('extra.params', item, [])"
            ></div>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>

      <v-list class="primary-drawer__nav primary-drawer__nav--settings pa-0" v-if="false">
        <v-list-tile
          ripple
          class="primary-drawer__link primary-drawer__link--settings tertiary--text"
          color="tertiary"
          @click="menu = !menu"
        >
          <v-list-tile-action v-if="!mini">
            <div class="v-icon v-icon--left">
              <fa-icon :icon="['far', 'cog']" size="sm" fixed-width style="opacity: 0.6" />
            </div>
          </v-list-tile-action>

          <v-tooltip right v-else>
            <template v-slot:activator="{ on }">
              <v-list-tile-action v-on="on">
                <div class="v-icon v-icon--left">
                  <fa-icon :icon="['far', 'cog']" size="sm" fixed-width style="opacity: 0.6" />
                </div>
              </v-list-tile-action>
            </template>
            <span>Settings</span>
          </v-tooltip>

          <v-list-tile-content>
            <v-list-tile-title>Settings</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </div>

    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-x
      :nudge-width="50"
      activator=".primary-drawer__link--settings"
      transition="slide-x-transition"
      content-class="settings-menu"
    >
      <v-card>
        <v-list dark class="secondary">
          <v-list-tile>
            <v-list-tile-action>
              <div class="v-icon v-icon--left">
                <fa-icon :icon="['far', privacy ? 'eye-slash' : 'eye']" size="sm" fixed-width />
              </div>
            </v-list-tile-action>
            <v-list-tile-title>Privacy</v-list-tile-title>
            <v-list-tile-action>
              <v-switch color="white" v-model="privacy"></v-switch>
            </v-list-tile-action>
          </v-list-tile>
          <!-- <v-list-tile>
						<v-list-tile-action>
							<div class="v-icon v-icon--left">
								<fa-icon :icon="['far', dark ? 'lightbulb-slash' : 'lightbulb-on']" size="sm" fixed-width/>
							</div>
						</v-list-tile-action>
						<v-list-tile-title>Dark Mode</v-list-tile-title>
						<v-list-tile-action>
							<v-switch color="white" v-model="dark"></v-switch>
						</v-list-tile-action>
          </v-list-tile>-->
          <v-list-tile v-if="canUseFluid">
            <v-list-tile-action>
              <div class="v-icon v-icon--left">
                <fa-icon :icon="['far', fluid ? 'expand' : 'compress']" size="sm" fixed-width />
              </div>
            </v-list-tile-action>
            <v-list-tile-title>Fluid</v-list-tile-title>
            <v-list-tile-action>
              <v-switch color="white" v-model="fluid"></v-switch>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-menu>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
var { computedUserSetting } = require("@root/helpers");
import Badge from "@components/partials/Badge";
import pathToRegexp from "path-to-regexp";

export default {
  data() {
    return {
      menu: false,
      canUseFluid: false
    };
  },

  components: { Badge },

  computed: {
    ...mapGetters({
      _mini: "mini",
      _dark: "dark",
      _privacy: "privacy",
      _fluid: "fluid",
      _primaryDrawer: "primaryDrawer",
      _displaySetting: "displaySetting"
    }),

    ...mapGetters(["items", "user", "profileDrawer", "drawerSizes"]),

    primaryDrawer: computedUserSetting("primaryDrawer"),
    mini: computedUserSetting("mini", true),
    dark: computedUserSetting("dark", true),
    privacy: computedUserSetting("privacy", true),
    fluid: computedUserSetting("fluid", true),

    primaryRoutes() {
      const routes = this.getObjectValue("options.routes", this.$router);

      return routes.reduce((carry, route) => {
        const isPrimary = this.getObjectValue("meta.primary", route);
        // we're only showing primary routes in navigation
        if (!isPrimary) {
          return carry;
        }

        const routeInPrivacy = this.getObjectValue("meta.in_privacy", route);
        // user.privacy === this.privacy:
        // if privacy is true, then the user cannot see the routes under privacy
        // aka: true: needs privacy
        const canUserSeePrivacy = !this.privacy;

        if (!routeInPrivacy || (routeInPrivacy && canUserSeePrivacy)) {
          carry.push({
            title: this.getObjectValue("meta.title", route),
            icon: this.getObjectValue("meta.icon", route),
            href: pathToRegexp.compile(this.getObjectValue("path", route))(),
            extra: this.getObjectValue("meta.extra", route)
          });
        }

        return carry;
      }, []);
    },

    fluidSidebar() {
      return this.$vuetify.breakpoint.width <= 1718 || this.fluid == 1;
    }
  },

  methods: {
    ...mapActions(["setUserSettingValue"]),

    ...mapMutations(["SET_VALUE"]),

    changeTitle(item) {
      this.page.title = item.title;
      this.page.icon = item.icon;
    },
    doNothing() {}
  },

  watch: {
    privacy(value) {
      if (
        value &&
        !this.getObjectValue("meta.in_privacy", this.$route, false)
      ) {
        this.$router.push({ path: "/quotes/create" });
      }
    }
  }
};
</script>
